import React from 'react'
import { ArrowRight, Users, Building, BookOpen } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { serviceStats } from '../../data/company'
import { emailUtils } from '../../utils/contactUtils'

const Hero: React.FC = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  return (
    <section className="relative pt-32 pb-20 lg:pt-40 lg:pb-32 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-blue-50 via-white to-gray-50"></div>
      
      <div className="container mx-auto px-4 relative">
        <div className="max-w-4xl mx-auto text-center">
          <div>
            <div className="inline-flex items-center px-4 py-2 bg-blue-100 text-blue-800 rounded-full text-sm font-medium mb-6">
              <span className="w-2 h-2 bg-blue-600 rounded-full mr-2"></span>
              {t('hero.subtitle')}
            </div>

            <h1 className="text-4xl lg:text-6xl font-bold text-gray-900 mb-6 leading-tight">
              {t('hero.title')}
            </h1>

            <p className="text-lg lg:text-xl text-gray-600 mb-8 leading-relaxed">
              {t('hero.description')}
            </p>

            <div className="flex justify-center space-x-4 mb-12">
              <button
                className="inline-flex items-center justify-center px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors duration-200 space-x-2"
                onClick={() => emailUtils.openConsultationEmail(t)}
              >
                <span>{t('hero.ctaButton')}</span>
                <ArrowRight size={18} />
              </button>
              
              <button
                className="inline-flex items-center justify-center px-6 py-3 bg-white text-blue-600 border border-blue-600 rounded-lg hover:bg-blue-50 transition-colors duration-200"
                onClick={() => navigate('/products')}
              >
                {t('hero.secondaryButton')}
              </button>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-2xl mx-auto">
              <div className="text-center">
                <div className="flex items-center justify-center mb-2">
                  <Users className="text-blue-600 mr-2" size={24} />
                  <span className="text-2xl lg:text-3xl font-bold text-gray-900">
                    {serviceStats.partners}
                  </span>
                </div>
                <p className="text-sm text-gray-600">{t('about.stats.projects')}</p>
              </div>
              
              <div className="text-center">
                <div className="flex items-center justify-center mb-2">
                  <Building className="text-blue-600 mr-2" size={24} />
                  <span className="text-2xl lg:text-3xl font-bold text-gray-900">
                    {serviceStats.libraries}
                  </span>
                </div>
                <p className="text-sm text-gray-600">{t('about.stats.countries')}</p>
              </div>
              
              <div className="text-center">
                <div className="flex items-center justify-center mb-2">
                  <BookOpen className="text-blue-600 mr-2" size={24} />
                  <span className="text-2xl lg:text-3xl font-bold text-gray-900">
                    {serviceStats.readers}
                  </span>
                </div>
                <p className="text-sm text-gray-600">{t('about.stats.satisfaction')}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Hero 